import { usePartyStore } from "@/Stores/partyStore";
import { useUserStore } from "@/Stores/userStore";
import { useCreditStore } from "@/Stores/creditStore";
import { useFeatureStore} from "@/Stores/featureStore";
import { usePromptStore } from "@/Stores/promptStore";
import { useUniversalChatStore } from "@/Stores/universalChatStore";

export const logoutService = {
    logout() {
        const partyStore = usePartyStore();
        const userStore = useUserStore();
        const creditStore = useCreditStore();
        const featureStore = useFeatureStore();
        const promptStore = usePromptStore();
        const universalChatStore = useUniversalChatStore();
        partyStore.clearPartyStore()
        userStore.clearUserStore()
        creditStore.clearCreditStore()
        featureStore.clearFeatureStore()
        promptStore.clearAll()
        universalChatStore.clearChatStore()
    }
}

